// "Accepted" only means the provider took the message; "Delivered" means the recipient's mail server confirmed it. Neither proves it reached the inbox.
export const DELIVERY_LABEL: Record<string, string> = {
  accepted: "Accepted by provider — delivery not yet confirmed",
  delivered: "Delivered to recipient’s mail server",
  delayed: "Delivery delayed — provider is retrying",
  bounced: "Bounced — not delivered",
  complained: "Marked as spam by recipient",
  failed: "Failed — not delivered",
  unknown: "Sent (no delivery tracking)",
  backup: "Sent via backup service — no delivery tracking",
};

const JOB_LABEL: Record<string, string> = {
  pending: "Queued", retrying: "Retrying", failed: "Sending failed", cancelled: "Cancelled",
  suppressed: "Not sent — address previously bounced or reported spam",
};

export function emailStatus(e: { status: string; delivery_status?: string; route?: string; fallback_reason?: string }): { label: string; tone: "ok" | "bad" | "muted" } {
  if (e.status !== "sent") return { label: JOB_LABEL[e.status] || e.status, tone: ["failed", "suppressed", "cancelled"].includes(e.status) ? "bad" : "muted" };
  const d = e.route === "resend" ? e.delivery_status || "accepted" : e.fallback_reason ? "backup" : "unknown";
  return { label: DELIVERY_LABEL[d] || d, tone: ["bounced", "complained", "failed"].includes(d) ? "bad" : d === "delivered" ? "ok" : "muted" };
}

export const TONE_CLASS = { ok: "text-primary", bad: "text-destructive", muted: "text-muted-foreground" } as const;
